import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
/**
 *
 * RadioGroup
 *
 */

import React from 'react';
import classnames from 'classnames';

var RadioGroup = function RadioGroup(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      selectedValue = _ref.selectedValue,
      name = _ref.name,
      disabled = _ref.disabled,
      extraClasses = _ref.extraClasses;
  var childrenWithProps = React.Children.map(children, function (child) {
    return React.cloneElement(child, _objectSpread({
      onChange: onChange,
      name: name,
      disabled: disabled
    }, selectedValue ? {
      checked: selectedValue === child.props.value
    } : {}));
  });
  return React.createElement("div", {
    className: classnames('radio-group', extraClasses)
  }, childrenWithProps);
};

RadioGroup.defaultProps = {
  extraClasses: '',
  onChange: function onChange() {},
  selectedValue: '',
  disabled: false
};
RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;